//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { MANAGE_COLLECTIONS_PERMISSION } from '@collections/constants/CollectionsConstants';
import SearchAndAddMenu from '@legacy-components/common/SearchAndAddMenu';

import { useBulkStreamCollections } from 'app/bulk-actions/hooks/useBulkStreamCollections';

export interface StreamItem {
  id: string | number;
  name: string;
}

interface StreamsBulkAddMenuProps {
  onSelectStream: (stream: StreamItem) => void;
  selectedStreamIds: Record<string, boolean>;
}

export const StreamsBulkAddMenu = ({
  onSelectStream,
  selectedStreamIds,
}: StreamsBulkAddMenuProps) => {
  const { createStream, isCreating, isLoading, streams } =
    useBulkStreamCollections();

  const handleCreate = (name: string) => {
    void createStream(name)
      .then((stream) => onSelectStream(stream))
      .catch(() => undefined);
  };

  return (
    <Wrapper>
      <SearchAndAddMenu
        createButtonLabel='Add To New Stream'
        createPermission={MANAGE_COLLECTIONS_PERMISSION}
        createPlaceholderText='Name your stream'
        itemsAsyncOutstanding={new Set()}
        listItems={streams}
        menuTitle='Your Streams'
        noItemsText={isLoading ? 'Loading...' : 'You have no streams.'}
        onAlreadyAdded={onSelectStream}
        onCreate={handleCreate}
        onSelect={onSelectStream}
        searchPlaceholderText='Find Stream...'
        selectedItems={selectedStreamIds}
        showCreateLoadingSpinner={isCreating}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div(
  ({ theme }) => `
  && .create-button {
    background: none;
    border: none;
    border-radius: 0;
    box-shadow: none;
    padding: 0;
  }

  && .create-button:focus-visible {
    outline: 2px solid ${theme.colors.aliases.primary};
    outline-offset: 2px;
  }

  && .create-button .create-icon,
  && .create-button .create-text {
    color: ${theme.colors.aliases.primary};
    font-weight: normal;
  }
`,
);
